import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useParams } from 'react-router-dom';

const VehicleDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="h4" gutterBottom>
        Détails du véhicule #{id}
      </Typography>
      
      <Typography variant="body1" color="text.secondary" paragraph>
        Informations détaillées du véhicule
      </Typography>

      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Informations du véhicule
        </Typography>
        <Typography color="text.secondary">
          Les détails complets du véhicule, l'historique de maintenance,
          les documents techniques et les informations de stationnement seront affichés ici.
        </Typography>
      </Paper>
    </Box>
  );
};

export default VehicleDetail; 